import { render, staticRenderFns } from "./ISPApplicationSummaryNew.vue?vue&type=template&id=0d95e60a&"
import script from "./ISPApplicationSummaryNew.vue?vue&type=script&lang=js&"
export * from "./ISPApplicationSummaryNew.vue?vue&type=script&lang=js&"
import style0 from "./ISPApplicationSummaryNew.vue?vue&type=style&index=0&id=0d95e60a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports